// @ts-nocheck
import { ChangeDetectorRef, Component, HostListener, Input, OnInit, NO_ERRORS_SCHEMA } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { MenuService } from '../../services/menu.service';
import { VendorService } from 'src/app/services/vendor.service';
import { environment } from '../../../../environments/environment';
import { UtilsDataService } from 'src/app/services/utils-data.service';
import { LogoService } from '../../services/logo.service';
import { UtilsService } from 'src/app/utils.service';
import { JobSeekerService } from 'src/app/job-seeker/job-seeker.service';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  standalone: true,
  selector: 'app-header-one',
  templateUrl: './header-one.component.html',
  styleUrl: './header-one.component.scss',
  imports: [CommonModule, RouterModule, MatTooltipModule],
  schemas: [NO_ERRORS_SCHEMA],
})
export class HeaderOneComponent implements OnInit {
  [key: string]: any;

  @Input() class: string = '';
  @Input() topbar: boolean = true;
  @Input() sticky: boolean = false;

  public stick: boolean = false;
  public isLoggedIn: boolean = false;
  public logo: string = 'assets/images/logos/Whiterobe-final-logo.svg';
  public myAcountMenu: any[] = [];
  public fullScreenDisplay: boolean = false;
  public host: string = '';
  public hostBarEnable: boolean = true;
  public companyName: string = '';
  public companyTitle: string = '';
  public isDefaultLogo: boolean = true;
  public profileData: any = {};

  private subscriptions: Subscription[] = [];

  constructor(
    private authService: AuthService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private menuService: MenuService,
    private vendorService: VendorService,
    private utilsDataService: UtilsDataService,
    private logoService: LogoService,
    private utilsService: UtilsService,
    private jobSeekerService: JobSeekerService
  ) {}

  ngOnInit(): void {
    // Subscribe to logo updates
    this.subscriptions.push(
      this.logoService.logo$.subscribe((url: string) => {
        this.logo = url;
        this.isDefaultLogo = url === 'assets/images/logos/Whiterobe-final-logo.svg';
        this.cdRef.detectChanges();
      })
    );

    // Subscribe to login status
    this.subscriptions.push(
      this.utilsService.profileActionData.subscribe((data: any) => {
        console.log('HeaderOne profileActionData:', data);
        this.isLoggedIn = data.loginStatus === true;
        this.profileData = data.profileData || {};
        this.cdRef.detectChanges();
      })
    );

    // Subscribe to auth service login status as well
    this.subscriptions.push(
      this.authService.getLoginStatus().subscribe((status: boolean) => {
        this.isLoggedIn = status;
        this.cdRef.detectChanges();
      })
    );

    // Load menu (my accounts dropdown)
    this.getMenus();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getMenus() {
    this.subscriptions.push(
      this.menuService.getMenu.subscribe((data: any) => {
        if (data && data['my_accounts_menu']) {
          this.myAcountMenu = data['my_accounts_menu'];
        }
      })
    );
  }

  logout(): void {
    this.authService.logout();
    this.utilsService.setLoggedInStatus({ loginStatus: false, role: '', profileData: {} });
    localStorage.clear();
    this.router.navigate(['/']);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.stick = offset >= 150;
  }

  goTo(link: any) {
    this.router.navigate([link]);
  }

  getCompanyDetailsByVendorId() {
    const uuid = this.utilsService.getUserUuid();
    if (!uuid) return;
    this.vendorService.getCompanyDetailsByVendorId({ uuid }).subscribe((res: any) => {
      if (res && res.data) {
        this.companyName = res.data.company_name || '';
        this.companyTitle = res.data.company_name || '';
        if (res.data.company_logo) {
          this.logoService.updateLogo(res.data.company_logo);
        }
      }
    });
  }

  onLogoError(event: Event) {
    (event.target as HTMLImageElement).src = 'assets/images/logos/Whiterobe-final-logo.svg';
  }

  goToDashboard() {
    const role = this.profileData?.role;
    if (role === 'VENDOR' || role === 'VENDOR_EMP') {
      this.router.navigate(['/vendor/hrms-dashboard']);
    } else if (role === 'ADMIN' || role === 'SUPER_ADMIN') {
      this.router.navigate(['/admin/dashboard']);
    } else {
      this.router.navigate(['/']);
    }
  }

  setFullScreen() {
    this.fullScreenDisplay = !this.fullScreenDisplay;
    if (this.fullScreenDisplay) {
      const el = document.documentElement;
      if (el.requestFullscreen) el.requestFullscreen();
    } else {
      if (document.exitFullscreen) document.exitFullscreen();
    }
  }
}
